import { render, staticRenderFns } from "./market-chart.vue?vue&type=template&id=30fb72ae"
import script from "./market-chart.vue?vue&type=script&lang=js"
export * from "./market-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports